module.exports = __webpack_public_path__ + "assets/img/ic-edit.c02f9062.svg";